import { useState, useEffect } from 'react';
import { gql } from '@apollo/client';
import performQuery from 'features/help/queries/contentfulClient';
import { Article } from '../types';

const ARTICLE_SLUGS_BY_ID = gql`
  query ArticleSlugsById($articleId: String!, $preview: Boolean) {
    ansArticle(id: $articleId, preview: $preview) {
      articleTitle
      slug
      subTopicCollection(limit: 5) {
        items {
          slug
          previewDescription
          topicName
          topicIcon {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          externalUrl
        }
      }
    }
  }
`;

export const useArticleSlugsById = (articleId?: string) => {
  const [data, setData] = useState<Article | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!articleId) return;

      setLoading(true);
      const response = await performQuery(ARTICLE_SLUGS_BY_ID, { articleId });

      if (response.hasError) {
        setError(true);
        setData(null);
      } else {
        setData(response.res?.data?.ansArticle as Article);
        setError(false);
      }
      setLoading(false);
    };

    fetchData();
  }, [articleId]);

  return { data, error, loading };
};
